export default (obj, ...path) => {
  return path.reduce((obj, key)=> ((!obj || !obj[key]) ? null : obj[key]), obj);
};



// WEBPACK FOOTER //
// ./src/utils/getattr.js